import {IconButton, ListItem, ListItemText, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import Icon from 'presentation/icons';
import {useMediaQueries} from 'presentation/pages';
import {StyledListItemIcon} from './styles';
import {DataInfoProps} from './types';
import {normalizeUrl} from 'presentation/utils/normalizeUrl';

function DataInfo({
	primaryText,
	secondaryText,
	iconName,
	iconColor,
	iconSize,
	listItemProps,
	removeItemTextMargin,
	primaryTextMaxWidth = '100%',
	secondaryTextMaxWidth = '100%',
	removePaddingBottom = false,
	primaryTextColor,
	secondaryTextColor,
	primaryTextFontSize = '1rem',
	secondaryTextFontSize = '0.875rem',
	primaryTextFontWeight = 400,
	secondaryTextFontWeight = 400,
	externalLinkUrl,
	removeIconMargin,
}: DataInfoProps) {
	const {palette} = useTheme();
	const {isLaptop, isTablet} = useMediaQueries();

	const sizeSmaller = '35vw';
	const sizeLaptop = isLaptop ? '45vw' : sizeSmaller;
	const sizeTablet = isTablet ? '50vw' : sizeLaptop;

	const handleExternalLinkClick = () => {
		if (externalLinkUrl) {
			window.open(normalizeUrl(externalLinkUrl), '_blank', 'noopener,noreferrer');
		}
	};

	return (
		<ListItem
			disableGutters
			sx={{paddingBottom: removePaddingBottom ? 0 : 1, paddingTop: 0}}
			alignItems={secondaryText ? 'flex-start' : 'center'}
			{...listItemProps}>
			{iconName ? (
				<StyledListItemIcon
					$removeItemTextMargin={removeItemTextMargin}
					$removeIconMargin={removeIconMargin}>
					<Icon
						name={iconName}
						color={iconColor ?? palette.primary.main}
						size={iconSize ?? 20}
					/>
				</StyledListItemIcon>
			) : null}
			<ListItemText
				sx={{margin: removeItemTextMargin ? 0 : 1}}
				slotProps={{
					primary: {
						textOverflow: 'ellipsis',
						overflow: 'hidden',
						maxWidth: primaryTextMaxWidth || sizeTablet,
						fontSize: primaryTextFontSize,
						color: primaryTextColor,
						fontWeight: primaryTextFontWeight,
					},
					secondary: {
						fontSize: secondaryTextFontSize,
						maxWidth: secondaryTextMaxWidth,
						color: secondaryTextColor,
						fontWeight: secondaryTextFontWeight,
					},
				}}
				primary={primaryText ?? null}
				secondary={
					externalLinkUrl ? (
						<Stack direction="row" component="span" alignItems="center" gap={0.5}>
							<Typography component="span" fontSize={'0.875rem'}>
								{externalLinkUrl}
							</Typography>
							<IconButton
								onClick={handleExternalLinkClick}
								size="small"
								aria-label="Open external link">
								<Icon name="ben-export" size={16} />
							</IconButton>
						</Stack>
					) : (
						(secondaryText ?? null)
					)
				}
			/>
		</ListItem>
	);
}

export {DataInfo};
